import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ActualCloseFilterService,
  ExpectedCloseFilterService,
  CreatedDateFilterService,
  AssignedDateFilterService,
} from './date-filters.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    ExpectedCloseFilterService,
    ActualCloseFilterService,
    CreatedDateFilterService,
    AssignedDateFilterService,
  ],
})
export class DateFiltersModule {}
